import React from 'react';
import cx from 'classnames';

import Icon from '../Icon';
import Text from '../Text';

import styles from './BreadcrumbItem.module.scss';
import usePresenter from './BreadcrumbItem.presenter';
import getProps from './BreadcrumbItem.props';
import { BreadcrumbItemCombinedProps } from './types';

const BreadcrumbItem: React.FC<BreadcrumbItemCombinedProps> = (props) => {
  const {
    state,
    className,
    classes,
    text,
    icon,
  } = usePresenter(props);

  const variantName = `${state}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`breadcrumbItem${variantName}`];

  let componentView;

  switch (variantName) {
    case 'Default': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <Text
            className={cx(styles.text, classes?.text)}
            {...internalProps.text}
            {...text}
          />
          <Icon
            className={cx(styles.icon, classes?.icon)}
            {...internalProps.icon}
            {...icon}
          />
        </div>
      );
      break;
    }
    case 'Selected': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <Text
            className={cx(styles.text, classes?.text)}
            {...internalProps.text}
            {...text}
          />
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
};

export default BreadcrumbItem;
